var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H2 } from 'syf-component-library/ui/typography';
import { useRewardsPageContext } from '../../../context/rewardsPageContext';
import IMAGE_ASSET_PATHS from '../../../../../const/assets';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import useRewards from '../../../../../hooks/useRewards';
import { CreditCardImage, EarnPointsText, ImgContainer, RegisteredMark, ShopMoreButton, ShopMoreContainer, ShopMoreHeader } from './subcomponents';
var ShopMore = function () {
    var _a, _b, _c, _d, _e;
    var _f = useState(false), isVertical = _f[0], setIsVertical = _f[1];
    var imgRef = useRef(null);
    var t = useTranslation().t;
    var config = useRewardsConfigContext().config;
    var _g = useRewards(), accountSummary = _g.accountSummary, clientId = _g.clientId, rewardsExperience = _g.rewardsExperience;
    var isActiveRewardsTab = useRewardsPageContext().state.isActiveRewardsTab;
    var assets = config.hosts.assets;
    var defaultCardArt = "".concat(config.hosts.assets, "/assets/cardArt/syf_generic_card.svg");
    var onClick = function () {
        var _a, _b;
        if (rewardsExperience && ((_a = rewardsExperience[clientId].actionButton) === null || _a === void 0 ? void 0 : _a.link)) {
            window.open((_b = rewardsExperience[clientId].actionButton) === null || _b === void 0 ? void 0 : _b.link, '_blank');
        }
    };
    var handleImageError = function (e, fallbackImage) {
        var event = e.target;
        if (event.src !== fallbackImage) {
            event.onerror = null;
            event.src = fallbackImage;
        }
    };
    /**
     * isActiveRewardsTab is true when current tab is rewards, otherwise false.
     */
    var earnPointsDesc = t("shopMore.earnPoints.default");
    if (isActiveRewardsTab) {
        earnPointsDesc = t("shopMore.earnPoints.".concat([clientId]));
    }
    var handleLoad = function () {
        if (!imgRef.current)
            return;
        var _a = imgRef.current, naturalHeight = _a.naturalHeight, naturalWidth = _a.naturalWidth;
        setIsVertical(naturalHeight > naturalWidth);
    };
    var formatTextWithMark = function (cardDisplayName) {
        var textSegments = cardDisplayName.split(/(®)/);
        return (_jsx(_Fragment, { children: textSegments.map(function (segment, index) {
                return segment === '®' ? (_jsx(RegisteredMark, { children: "\u00AE" }, index)) : (segment);
            }) }));
    };
    return (_jsxs(ShopMoreContainer, { children: [_jsxs(ImgContainer, { children: [_jsx("img", { src: "".concat(assets.origin, "/").concat(IMAGE_ASSET_PATHS.SPARKS_ANIMATION), alt: "spark animation" }), _jsx(CreditCardImage, { src: (_b = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card) === null || _a === void 0 ? void 0 : _a.cardArtURL) !== null && _b !== void 0 ? _b : defaultCardArt, onError: function (e) { return handleImageError(e, defaultCardArt); }, ref: imgRef, onLoad: handleLoad, vertical: isVertical })] }), _jsx(ShopMoreHeader, __assign({ weight: "bold" }, { children: t('shopMore.earnMoreRewards') })), (accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.displayName) && (_jsxs(H2, { children: ["".concat(t('shopMore.withYour'), " "), formatTextWithMark(accountSummary.product.displayName)] })), rewardsExperience && _jsx(EarnPointsText, { children: earnPointsDesc }), rewardsExperience && ((_d = (_c = rewardsExperience[clientId]) === null || _c === void 0 ? void 0 : _c.actionButton) === null || _d === void 0 ? void 0 : _d.text) && (_jsx(ShopMoreButton, __assign({ buttonType: "primary", onClick: onClick, "data-type": "rewards", "data-reason": "Go To Rewards", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: t((_e = rewardsExperience[clientId].actionButton) === null || _e === void 0 ? void 0 : _e.text) })))] }));
};
export default ShopMore;
